<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lof5W6/tc-custom/9780830848874.jpg?1696363322998" alt="This image is the cover for the book The Paradox of Sonship, Studies in Christian Doctrine and Scripture"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Paradox of Sonship, Studies in Christian Doctrine and Scripture
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>Biblical Foundations Book Awards Runner Up and Finalist</strong> </p> <p> <strong>What does the epistle to the Hebrews mean when it calls Jesus "Son"?</strong> Is "Son" a title that denotes his eternal existence as one person of the Trinity? Or is it a title Jesus receives upon his installation on heaven's throne after his resurrection and ascension?</p> <p>In this Studies in Christian Doctrine and Scripture (SCDS) volume, which promotes fresh understandings of Christian belief through creative, faithful readings of the canonical text, pastor and New Testament scholar R. B. Jamieson probes the complexity of the Christology presented in the epistle to the Hebrews.</p> <p>Exploring the paradox of this key term, Jamieson argues that, according to Hebrews, "Son" names both who Jesus is eternally and what he becomes at the climax of his incarnate, saving mission. Jesus is, in short, the eternal Son who became the messianic Son for us and for our salvation. This volume thereby offers a case study showing how the church's core convictions about Christ lead us not away from the text, but deeper into it.</p> <p>Studies in Christian Doctrine and Scripture, edited by Daniel J. Treier and Kevin J. Vanhoozer, promotes evangelical contributions to systematic theology, seeking fresh understanding of Christian doctrine through creatively faithful engagement with Scripture in dialogue with church.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R. B. Jamieson
      </h2>
      
      <p class="authorDescription body article"><p>R. B. Jamieson (PhD, University of Cambridge) is associate pastor of Capitol Hill Baptist Church in Washington, DC. He is the author of several books, including <em>Sound Doctrine: How a Church Grows in the Love and Holiness of God</em>, <em>Understanding Baptism</em>, <em>Understanding the Lord's Supper</em>, and <em>Jesus' Death and Heavenly Offering in Hebrews</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c4e4b3a2